import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getRem, truncateText, typographySubtitle2 } from './../../core';

const StyledCaptionContainer = styled.figcaption`
  align-items: flex-end;
  background: ${({ theme }) =>
    `linear-gradient(0deg, ${theme.color.card.imageGradientBaseStart.value} 0%, ${theme.color.card.imageGradientBaseEnd.value} 100%)`};
  border-radius: inherit;
  display: flex;
  height: ${getRem('56px')};
  width: 100%;
`;

const StyledCaptionTitle = styled.span`
  ${({ theme }) => typographySubtitle2(theme)};
  color: ${({ theme }) => theme.color.card.imageCaption.value};
  margin: ${({ theme }) => `0 ${theme.size.spacing.large.value} ${theme.size.spacing.medium.value}`};
  ${truncateText};
`;

const CardMediaCaption = ({ children = undefined, ...other }) => (
  <StyledCaptionContainer {...other}>
    <StyledCaptionTitle>{children}</StyledCaptionTitle>
  </StyledCaptionContainer>
);

CardMediaCaption.propTypes = {
  /** Any content inserted between component tags */
  children: PropTypes.node,
};

export { CardMediaCaption };
